<template>
  <div>
    <SeedJung_Header></SeedJung_Header>
    <h2 class="h2_ing">상담 진행 과정</h2>
    <div class="consultation-page">
      <div class="content-wrapper">
        <div class="process-flow">
          <div class="step" v-for="(step, index) in steps" :key="index">
            <div class="step-icon" v-html="step.icon"></div>
            <div class="step-content">
              <h3>STEP {{ index + 1 }}</h3>
              <p class="description">{{ step.description }}</p>
            </div>
          </div>
        </div>
        <div class="application-form">
          <!-- <span style="padding: 10px 15px; text-align: left;">상담 신청은 로그인이 필요합니다.</span> -->
          <div class="page-header">
            <h2 class="page-title">상담 신청</h2>
            <button v-if="!isFormVisible" @click="showForm" class="write-button">상담 신청</button>
          </div>
          <!-- 상담 신청 리스트 섹션 -->
          <div class="consultation-list">
            <SeedJung_ConsultingTable 
              v-if="!isFormVisible"
              :consultations="consultations"
              :currentPage="currentPage"
              :totalPages="totalPages"
              :totalItems="totalItems"
              :items-per-page="effectiveItemsPerPage"  
              @search="searchConsultations"
              @changePage="changePage"
              @openConsultation="handleOpenConsultation"
            />
          </div>
          <form v-if="isFormVisible" @submit.prevent="submitForm">
            
            <!-- <a href="https://blog.naver.com/alscofld95" target="_blank" class="inquiry-link">Q 상담에 대한 자주 묻는 질문</a><br /><br /> -->
            <div class="form-group">
              <label for="title">제목</label>
              <input type="text" id="title" v-model="form.title" required>
            </div>
            <div class="form-group">
              <label for="author">작성자</label>
              <input type="text" id="author" v-model="form.author" required>
            </div>
            <div class="form-group">
              <label for="content">내용</label>
              <textarea id="content" v-model="form.content" required></textarea>
            </div>
            <div class="form-buttons">
              <button type="submit" class="submit-btn">상담 신청</button>
              <button type="button" class="cancel-btn" @click="cancelForm">취소</button>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import SeedJung_Header from './SeedJung_Header.vue';
import SeedJung_ConsultingTable from './SeedJung_ConsultingTable.vue';
import axios from 'axios';

export default {
 name: 'SeedJung_Consulting',
 components: {
   SeedJung_Header,
   SeedJung_ConsultingTable
 },
 data() {
   return {
     isFormVisible: false,
     isMobile: false,
     form: {
       title: '',
       author: this.$store.getters.currentUser ? this.$store.getters.currentUser.nickname : '',
       content: `상담 신청은 매우 간단합니다.
상담 신청 하실 때, 사연을 함께 남겨주시면 조금 더 빠른 일정으로 안내가 가능합니다.
우선, 아래의 양식에 맞춰 사연을 작성해주세요.

<사연 작성 양식>
1. 우선 상황을 간단히 요약하여 적어주세요.
(상담을 신청하게 된 계기에 대하여 적어주세요)
예시) 어릴적부터 마른거에 대한 트라우마가 있었습니다. 등등


2.작성자의 프로필에 대해서 자유롭게 서술해주세요.
(나이, 성격, 직업, 이름, 성격, 가치관 등)
밝히고 싶지 않은 부분에 대해서는 서술하지 않으셔도 좋습니다.
평소 성격이나 내담자의 트라우마, 컴플렉스 등에 대해서 써주시면 분석에 도움이 됩니다.


3. 체중증가를 위해 노력했던 과정들이 있다면, 자세히 서술해주세요. 
(1번의 요약본을 자세하게 풀어서 작성해주시면 됩니다.)
예시) 식단관리를 해보고, 운동도 해봤다. 한약도 먹어보았다 등등 


4. 어떻게 해결되기를 바라시나요?
(자신감 회복, 벌크업, 체중증가, 체력회복, 상담사가 알아서 해달라 등)


5. 그 외에 하고 싶은 말씀


6. 이전에 상담이나 운동 등 피티를 받으셨던 이력이 있다면 알려주세요 (선택)
예시) 
2018년 1월 / 10회 피티 / 헬스 2개월
2019년 4월 ~ 7월 / 수영
2020년 ~ 23년 / 태권도, 합기도 등등


**중요!)
반드시 "A4 5페이지 이내 (글자수 기준 8,000자)" 이내의 분량으로 작성해주세요.
일정이 예약되더라도, 분량 초과시 상담 진행이 되지 않으니 꼭 체크 부탁 드립니다.
간혹 모든 상황을 전해야 제대로 분석이 될 것이라는 불안감에 분량을 초과하시는 경우가 있습니다.
그러나 저희는 전문가입니다.
짧게 써주셔도 충분히 상황을 파악할 수 있으며, 길기만 한 글은 오히려 정확한 분석에 방해가 됩니다.
부족하거나 모호한 부분이 있다면, 상담사가 추가적인 질문을 할 것이니 불안해 하지 않으셔도 됩니다.


<상담 예약 과정>
1. 사연을 등록하게 되면 자동 댓글이 달립니다.
꼭 댓글을 확인해주세요.

2. 관리자가 확인 후 상담 일정을 안내해드릴 것입니다.
모든 안내는 댓글로 이루어지니, 상담일이 확정되기 전까지 지속적으로 댓글 확인 부탁드립니다.
댓글 확인이 늦어질 경우, 상담 일정이 많이 지연될 수 있습니다.`
     },
     consultations: [],
     currentPage: 1,
     totalItems: 0,
     steps: [
       {
         description: '"상담신청" 클릭 후, \n 사연을 작성합니다.',
         icon: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7"></path><path d="M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z"></path></svg>'
       },
       {
         description: '댓글 안내에 따라\n 필요한 정보를 입력합니다.',
         icon: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M21 11.5a8.38 8.38 0 0 1-.9 3.8 8.5 8.5 0 0 1-7.6 4.7 8.38 8.38 0 0 1-3.8-.9L3 21l1.9-5.7a8.38 8.38 0 0 1-.9-3.8 8.5 8.5 0 0 1 4.7-7.6 8.38 8.38 0 0 1 3.8-.9h.5a8.48 8.48 0 0 1 8 8v.5z"></path></svg>'
       },
       {
         description: '관리자가 확인 후, \n일정을 안내해드립니다.',
         icon: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><rect x="3" y="4" width="18" height="18" rx="2" ry="2"></rect><line x1="16" y1="2" x2="16" y2="6"></line><line x1="8" y1="2" x2="8" y2="6"></line><line x1="3" y1="10" x2="21" y2="10"></line></svg>'
       },
       {
         description: '상담 일정이 확정됩니다.',
         icon: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M22 11.08V12a10 10 0 1 1-5.93-9.14"></path><polyline points="22 4 12 14.01 9 11.01"></polyline></svg>'
       },
       {
         description: '정해진 일정에 상담이 진행됩니다.',
         icon: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"></path><circle cx="9" cy="7" r="4"></circle><path d="M23 21v-2a4 4 0 0 0-3-3.87"></path><path d="M16 3.13a4 4 0 0 1 0 7.75"></path></svg>'
       }
     ]
   }
 },
 computed: {
   effectiveItemsPerPage() {
    // 테이블 페이지 처리개수 모바일 7, 데스크톱 10
     return this.isMobile ? 7 : 10;
   },
   paginatedConsultations() {
     const start = (this.currentPage - 1) * this.effectiveItemsPerPage;
     const end = start + this.effectiveItemsPerPage;
     return this.consultations.slice(start, end);
   },
   totalPages() {
     return Math.ceil(this.totalItems / this.effectiveItemsPerPage);
   }
 },
 methods: {
   checkMobile() {
     this.isMobile = window.innerWidth <= 768;
   },
   handleResize() {
     const wasMobile = this.isMobile;
     this.checkMobile();
     if (wasMobile !== this.isMobile) {
       this.fetchConsultations();
     }
   },
   handleOpenConsultation(id) {
     console.log(`상담 ID ${id} 열기`);
     this.$router.push(`/consultation/${id}`);
   },
   showForm() {
     if (!this.$store.getters.currentUser) {
       alert('상담 신청은 로그인이 필요합니다.');
       this.$router.push('/login');
       return;
     }
     this.isFormVisible = true;
   },
   async submitForm() {
     try {
       const formData = {
         ...this.form,
         username: this.$store.getters.currentUser?.username?.trim() || ''
       };

       const response = await axios.post('/api/consultations', formData);
       console.log('상담 신청 완료:', response.data);
       
       alert(response.data.message);
       this.resetForm();
       window.location.href = '/consulting';
     } catch (error) {
       console.error('상담 신청 실패:', error);
       alert('상담 신청 중 오류가 발생했습니다. 다시 시도해 주세요.');
       window.location.href = '/consulting';
     }
   },
   cancelForm() {
     this.isFormVisible = false;
     this.resetForm();
   },
   resetForm() {
     this.form = {
       title: '',
       author: '',
       content: ''
     };
   },
   async fetchConsultations() {
     try {
       const response = await axios.get('/api/consultations', {
         params: {
           page: this.currentPage,
           itemsPerPage: this.effectiveItemsPerPage
         }
       });
       this.consultations = response.data.consultations;
       this.totalItems = response.data.totalItems;
       this.currentPage = response.data.currentPage;
     } catch (error) {
       console.error('상담 데이터를 불러오는 데 실패했습니다:', error);
     }
   },
   changePage(newPage) {
     this.currentPage = newPage;
     this.fetchConsultations();
   },
   async searchConsultations(searchTerm) {
     try {
       const response = await axios.get('/api/consultations', {
         params: {
           page: 1,
           itemsPerPage: this.effectiveItemsPerPage,
           search: searchTerm
         }
       });
       this.consultations = response.data.consultations;
       this.totalItems = response.data.totalItems;
       this.currentPage = 1;
     } catch (error) {
       console.error('검색 중 오류가 발생했습니다:', error);
     }
   }
 },
 created() {
   this.checkMobile();
   window.addEventListener('resize', this.handleResize);
   this.fetchConsultations();
 },
 beforeUnmount() {
   window.removeEventListener('resize', this.handleResize);
 }
}
</script>

<style scoped>
.consultation-page {
  display: flex;
  justify-content: center;
  padding: 20px;
}

.content-wrapper {
  display: flex;
  flex-direction: column;
  align-items: center;
  max-width: 1200px;
  width: 100%;
}

.process-flow {
  display: flex;
  justify-content: space-between;
  width: 100%;
  margin-bottom: 40px;
}

.application-form {
  width: 100%;
  max-width: 1200px;
}

.step {
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 18%;
  text-align: center;
}

.step-icon {
  width: 40px;
  height: 40px;
  margin-bottom: 10px;
  color: #072c53;
}

.step-content h3 {
  margin: 0 0 5px 0;
  font-size: 19px;
}

.step-content p {
  margin: 0;
  font-size: 14px;
}

h2 {
  margin-bottom: 20px;
}

.h2_ing {
  margin-top: 170px;
  text-align: center
}

.form-group {
  margin-bottom: 15px;
}

label {
  display: block;
  margin-bottom: 5px;
}

input, textarea {
  width: 100%;
  padding: 8px;
  border: 1px solid #ddd;
  border-radius: 4px;
}

textarea {
  height: 400px;
  resize: vertical;
}

.submit-btn, .cancel-btn {
  padding: 10px 15px;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  font-size: 16px;
  transition: background-color 0.3s;
}

.submit-btn {
  background-color: #4CAF50;
  color: white;
}

.cancel-btn {
  background-color: #f2f2f2;
  color: #072c53;
  border: 1px solid #072c53;;
  margin-left: 10px;
}

.submit-btn:hover {
  background-color: #072c53;
}

.cancel-btn:hover {
  background-color: #e0e0e0;
}

.form-header {
  display: flex;
  justify-content: flex-end;
  width: 100%;
  margin-bottom: 20px;
}

/* .show-form-btn {
  background-color:#072c53;
  color: white;
  padding: 10px 15px;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  font-size: 16px;
}

.show-form-btn:hover {
  background-color: #072c53;
} */
.show-form-btn {
  display: none;
}
.form-buttons {
  display: flex;
  justify-content: flex-start;
  margin-top: 20px;
}
.inquiry-link {
  text-decoration: none;
  color: #4CAF50;
  font-weight: 400;
  font-size: 14px;
  padding: 2px 0;
  border: none;
  border-bottom: 1px solid #072c53;
  transition: all 0.2s ease;
  display: inline-block;
}

.inquiry-link:hover {
  color: #072c53;
  border-bottom: 2px solid #072c53;
}
.page-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 30px;
  padding-bottom: 15px;
  border-bottom: 2px solid #072c53;
}

.page-title {
  font-size: 24px;
  color: #072c53;
  font-weight: 600;
  margin: 0;
}

.write-button {
  background: #072c53;
  color: white;
  border: none;
  padding: 8px 16px;
  border-radius: 4px;
  cursor: pointer;
  font-size: 14px;
  white-space: nowrap;
  min-width: 90px;
}
@media (max-width: 768px) {
  .process-flow {
    flex-direction: column;
    align-items: center;
  }

  .step {
    width: 100%;
    margin-bottom: 20px;
  }
  .h2_ing {
    margin-top: 85px;
    text-align: center
  }  
  .step-content h3 {
    margin: 0 0 5px 0;
    font-size: 17px;
  }  
  .page-title {
    font-size: 20px;
  }
}
.description {
  white-space: normal; /* 기본적으로 줄바꿈 없음 */
}

@media (min-width: 769px) {
  .description {
    white-space: pre-line; /* PC 버전에서만 줄바꿈 적용 */
  }

}
</style>